<template>
  <div class="Artists Page__container">

    <div class="Artists__block" v-for="oeuvre in oeuvres">
      <div class="Artists__col is-left">
        <h1>{{ oeuvre.author }}</h1>
        <div class="Artists__text" v-if="oeuvre[lang].author" v-html="oeuvre[lang].author.bio" />
      </div>
      <div class="Artists__col is-right">
        <h3>{{ oeuvre[oeuvre.titre_original].title }}</h3>
        <h3>{{ oeuvre.year }}</h3>
        <img v-lazy="oeuvre.image.sizes.large" class="Vlazy" />
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Artists',
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Artists
  position relative
  max-width 800px

  h1
  h3
    color grad_blue1

  &__block
    lost-utility clearfix
    margin-bottom 100px

  &__text
    font-size 17px
    line-height 28px

  &__col
    &.is-left
      lost-column 2/3 2 40px
      h1
        margin-top 0px
    &.is-right
      lost-column 1/3 2 40px
      img
        display block
        margin-top 30px

</style>




// WEBPACK FOOTER //
// src/components/navigation/pages/Artists.vue